import { Navigate, Outlet, useLocation } from "react-router";
import { useAuthStore } from "@/stores/auth";
import { useTranslation } from "@/i18n/use-translation";

/** Route guard that requires authentication only (no org check). Used for /waiting. */
export function AuthRoute() {
  const { t } = useTranslation();
  const user = useAuthStore((s) => s.user);
  const isLoading = useAuthStore((s) => s.isLoading);
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <p className="text-sm text-muted-foreground">{t("common.loading")}</p>
      </div>
    );
  }

  if (!user) {
    const returnTo = location.pathname + location.search;
    return <Navigate to={`/login?redirect=${encodeURIComponent(returnTo)}`} replace />;
  }

  return <Outlet />;
}
